/**
 * DescopedPromise class.
 *
 * Useful for integrating a promise into a Vue component that uses code that does not easily fit into the async/await
 * pattern.
 *
 * The resolve/reject arguments to the promise executor are made available on the instance object for external calling.
 */
class DescopedPromise {
    constructor(callback = null) {
        let res, rej;

        let promise = new Promise((resolve, reject) => {
            if(typeof callback === 'function') {
                callback(resolve, reject);
            }

            // Make resolve and reject available on instance object
            res = resolve;
            rej = reject;
        });

        promise.resolve = res;
        promise.reject = rej;

        return promise;
    }
}

export default DescopedPromise;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/tools/descoped-promise.js